import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import {
  prevProjectMappingsSelector,
  projectMappingsSelector,
} from 'src/selectors/projectMappings';

export const projectMappingSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string | undefined) =>
    createSelector(
      projectMappingsSelector(projectId),
      (mappings) =>
        (mappingId &&
          mappings.find((mapping) => mapping.value === mappingId)) ||
        null
    )
);

export const prevProjectMappingSelector = memoizeSelectorFactory(
  (projectId: string, mappingId: string | undefined) =>
    createSelector(
      prevProjectMappingsSelector(projectId),
      (mappings) =>
        (mappingId &&
          mappings.find((mapping) => mapping.value === mappingId)) ||
        null
    )
);
